import React from "react";

const Arbok = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-1.2 -0.2 243.1 312.2"
      {...rest}
    >
      <g>
        <path
          fill="#0d131a"
          d="M42.5 170.55 Q46.55 164.35 49.55 164.9 54.1 165.75 51.75 175.2 48.95 186.5 36.8 202.2 27.6 214.0 26.7 222.65 25.8 231.05 33.15 231.85 36.65 232.25 49.6 228.6 L79.0 220.25 Q125.35 207.7 158.15 207.6 195.5 207.45 213.25 226.75 219.85 233.9 223.0 243.1 225.45 250.3 225.35 256.9 225.1 274.8 216.65 282.6 205.8 292.65 181.3 286.25 177.9 285.4 176.1 280.65 175.4 278.75 173.65 270.9 172.25 264.45 170.45 261.6 167.8 257.5 162.85 257.5 150.7 257.5 119.05 265.35 85.45 273.7 76.55 274.35 43.35 276.85 24.65 269.25 6.05 261.65 1.45 243.8 -1.2 233.4 1.2 224.85 3.15 217.75 9.15 210.6 12.0 207.15 21.2 198.2 29.35 190.3 33.35 184.8 L42.5 170.55"
        />
        <path
          fill="#827aa0"
          d="M43.6 172.55 Q47.1 166.7 49.0 167.15 52.1 167.8 49.0 176.85 45.25 187.9 33.5 202.55 26.2 211.65 24.6 220.75 22.65 231.5 31.55 233.9 34.45 234.65 47.85 231.2 L78.5 222.85 Q127.2 209.95 156.9 209.95 192.8 209.95 209.75 227.25 221.65 239.4 222.65 257.5 216.45 261.75 212.55 268.35 210.4 272.05 207.4 278.45 204.55 283.25 200.1 284.6 194.5 286.3 183.55 283.8 180.3 283.05 178.4 278.2 177.6 276.2 175.6 268.0 173.95 261.25 172.1 258.25 169.35 253.9 164.65 253.9 152.9 253.9 118.7 262.15 81.9 271.0 73.9 271.75 45.2 274.4 26.9 267.15 8.1 259.65 3.8 243.0 -0.65 225.6 11.65 211.0 14.45 207.65 23.45 198.85 31.35 191.25 35.15 186.0 L43.6 172.55"
        />
        <path
          fill="#675f80"
          d="M134.4 240.55 Q138.05 236.9 145.65 236.35 161.15 235.3 164.65 239.9 168.2 244.55 157.25 252.1 135.3 256.9 136.45 256.35 142.3 253.5 138.0 250.55 130.0 245.0 134.4 240.55"
        />
        <path
          fill="#675f80"
          d="M96.55 253.8 L99.85 263.15 Q88.65 270.05 74.7 271.85 L56.25 272.4 Q38.65 272.2 26.35 267.1 14.4 262.15 8.1 252.8 13.35 258.75 24.35 262.3 34.9 265.7 48.05 266.05 61.5 266.4 73.9 263.45 87.3 260.25 96.55 253.8"
        />
        <path
          fill="#0d131a"
          d="M49.05 247.3 Q50.2 239.9 54.55 234.1 59.1 228.0 65.85 225.55 L67.15 225.15 Q51.2 234.05 50.35 250.3 50.0 257.15 52.75 263.4 55.4 269.6 60.25 273.35 L59.4 273.75 Q53.05 269.05 50.35 261.7 47.85 254.85 49.05 247.3"
        />
        <path
          fill="#0d131a"
          d="M34.7 233.55 L36.15 233.4 Q27.2 238.7 25.4 248.25 24.15 254.7 25.45 260.35 26.7 265.85 29.95 268.95 L28.65 268.65 Q25.55 265.85 24.15 260.4 22.55 254.4 23.95 247.85 25.1 242.5 28.3 238.6 31.05 235.3 34.7 233.55"
        />
        <path
          fill="#0d131a"
          d="M25.3 226.35 L25.15 227.15 Q14.8 226.45 9.05 232.95 4.05 238.65 4.6 246.75 L3.8 245.1 Q3.55 236.55 8.6 231.4 14.35 225.45 25.3 226.35"
        />
        <path
          fill="#0d131a"
          d="M11.35 210.4 L11.9 209.8 Q16.8 208.2 20.85 210.0 24.9 211.75 26.25 216.15 L25.75 216.9 Q24.6 212.4 19.8 210.75 15.8 209.35 11.35 210.4"
        />
        <path
          fill="#0d131a"
          d="M26.6 194.9 L27.05 194.25 Q35.1 192.45 36.3 199.55 L35.85 200.05 Q34.95 196.4 32.1 195.25 L26.6 194.9"
        />
        <path
          fill="#0d131a"
          d="M35.95 183.85 L36.3 183.3 Q39.5 182.1 41.8 183.3 44.2 184.5 44.5 187.7 L44.05 188.15 Q43.45 185.2 41.05 184.15 L35.95 183.85"
        />
        <path
          fill="#0d131a"
          d="M41.15 175.65 L41.35 175.2 Q44.15 173.45 46.65 174.55 49.0 175.6 49.35 178.1 L49.1 178.5 Q47.85 175.65 45.55 175.05 43.55 174.5 41.15 175.65"
        />
        <path
          fill="#0d131a"
          d="M158.75 252.25 L157.85 251.5 Q156.65 232.6 167.35 221.95 177.2 212.2 190.9 214.25 L192.55 214.95 Q176.35 213.75 166.95 225.05 158.3 235.6 158.75 252.25"
        />
        <path
          fill="#0d131a"
          d="M158.5 252.65 L157.85 251.5 Q165.65 242.05 177.0 238.2 187.15 234.75 197.9 236.45 208.1 238.0 215.3 243.5 222.7 249.1 223.85 256.6 L224.85 260.5 Q221.95 250.2 213.5 244.15 205.6 238.55 194.65 237.8 184.15 237.05 174.4 240.95 164.25 245.0 158.5 252.65"
        />
        <path
          fill="#0d131a"
          d="M210.05 52.65 Q224.95 63.8 233.2 78.15 241.4 92.5 241.6 107.5 241.9 131.7 222.4 151.0 206.75 166.5 183.75 174.65 170.5 179.35 162.15 192.15 154.9 203.25 152.75 217.9 150.8 231.4 153.85 241.9 156.95 252.65 163.7 254.15 174.35 248.35 200.8 251.2 214.05 252.6 225.15 255.15 227.5 282.75 204.4 298.05 183.25 312.0 147.6 311.85 126.5 311.75 109.7 304.55 93.4 297.55 84.75 285.55 77.55 275.55 76.25 264.2 75.2 254.95 78.05 243.15 79.35 237.8 84.55 222.15 88.95 208.9 90.25 200.85 91.4 193.65 87.9 186.3 83.3 176.8 71.6 169.65 43.7 152.6 30.5 137.9 16.9 122.7 16.9 107.85 16.9 69.95 52.15 47.65 67.55 37.9 87.65 32.75 106.9 27.8 127.45 27.8 152.35 27.8 174.15 34.6 194.55 41.0 210.05 52.65"
        />
        <path
          fill="#827aa0"
          d="M205.7 52.6 Q221.1 63.35 229.5 77.5 238.25 92.2 238.25 108.75 238.25 130.05 221.65 147.25 207.0 162.4 181.05 172.95 168.0 178.3 159.7 190.95 152.4 202.15 150.25 216.5 148.2 229.9 151.3 240.8 154.45 251.9 161.5 255.0 L160.9 252.8 161.0 252.9 Q171.2 245.85 197.85 249.4 211.15 251.2 222.45 254.4 224.75 279.35 204.65 294.05 184.1 309.0 146.2 308.75 127.3 308.65 111.8 302.1 95.3 295.2 85.95 282.25 74.2 265.8 82.2 237.45 L89.25 216.15 Q93.15 204.6 93.15 199.05 93.15 190.8 89.15 183.4 84.35 174.6 74.6 168.45 48.65 152.15 36.5 139.95 20.4 123.8 20.0 107.8 19.6 91.2 27.65 76.65 35.4 62.65 50.1 52.1 64.75 41.65 84.3 36.0 104.35 30.2 127.1 30.2 149.8 30.2 170.35 36.15 190.4 41.95 205.7 52.6"
        />
        <path
          fill="#675f80"
          d="M99.1 295.3 Q87.35 287.15 82.7 276.7 103.95 299.1 137.25 304.6 148.45 306.45 161.2 306.35 L176.95 305.7 Q166.2 308.35 152.7 308.75 138.4 309.2 126.9 306.85 111.15 303.65 99.1 295.3"
        />
        <path
          fill="#0d131a"
          d="M158.05 252.8 L159.25 251.7 Q159.7 252.95 170.75 257.55 182.55 263.6 186.4 271.9 190.05 279.75 188.3 290.35 186.6 301.0 180.75 305.85 L179.45 305.65 Q184.95 301.0 186.5 290.2 187.95 279.95 184.9 273.25 180.8 264.35 170.15 258.95 L162.65 255.55 Q159.0 253.95 158.05 252.8"
        />
        <path
          fill="#0d131a"
          d="M156.7 250.65 L158.55 251.65 Q159.35 259.45 157.0 268.35 154.2 278.95 148.0 285.45 139.9 293.9 125.75 298.05 114.45 301.4 105.8 300.7 L104.55 299.75 Q116.6 299.15 125.4 296.4 137.45 292.65 146.4 284.25 152.45 278.6 155.55 267.4 158.35 257.1 156.7 250.65"
        />
        <path
          fill="#0d131a"
          d="M94.05 241.9 Q105.85 238.55 114.95 238.75 127.25 239.05 139.5 242.55 151.25 245.85 156.55 250.2 L158.0 252.15 Q139.0 241.35 117.35 240.8 95.7 240.2 78.5 250.0 L78.8 248.65 Q82.65 245.15 94.05 241.9"
        />
        <path
          fill="#675f80"
          d="M163.3 178.6 Q168.0 173.55 177.0 169.45 182.3 167.0 194.4 162.35 205.6 157.7 213.25 152.4 223.65 145.15 231.3 134.5 224.4 146.6 210.8 156.7 198.35 165.95 181.05 172.95 167.5 178.5 159.1 191.95 151.7 203.8 149.95 218.75 149.4 208.95 152.05 199.3 155.4 187.0 163.3 178.6"
        />
        <path
          fill="#675f80"
          d="M74.9 49.6 L76.3 55.15 Q67.45 56.85 57.25 61.9 52.45 64.3 46.0 68.75 38.05 74.2 34.0 78.6 36.55 74.7 43.8 67.9 50.65 61.4 55.05 58.45 60.1 55.1 66.65 52.45 71.05 50.65 74.9 49.6"
        />
        <path
          fill="#0d131a"
          d="M74.15 50.75 Q70.6 51.65 65.15 54.1 59.25 56.75 54.85 59.65 51.15 62.1 44.7 67.9 37.9 74.15 33.8 79.0 36.2 75.0 43.15 67.85 49.8 60.95 54.05 57.85 58.95 54.3 65.35 51.35 69.65 49.35 73.5 48.15 L74.15 50.75"
        />
        <path
          fill="#0d131a"
          d="M189.3 135.0 Q190.45 133.8 190.7 133.9 191.0 134.05 190.45 135.85 185.9 151.65 173.9 161.15 162.3 170.3 145.35 172.5 134.75 173.85 128.3 176.8 122.4 179.45 118.6 184.1 L117.2 185.4 Q116.95 185.45 116.4 184.55 113.25 179.15 109.35 175.85 104.2 171.55 94.95 168.05 65.55 156.9 58.15 141.85 57.55 140.65 57.75 140.25 57.95 139.8 59.3 140.95 71.4 151.45 87.35 150.9 104.35 150.25 114.65 136.65 115.7 135.2 116.05 135.2 116.45 135.2 117.6 136.6 123.4 143.85 132.4 147.85 141.2 151.75 151.3 151.8 173.7 151.8 189.3 135.0"
        />
        <path
          fill="#152139"
          d="M172.55 149.4 Q182.0 145.25 187.9 138.2 183.9 151.0 173.0 159.55 161.0 168.95 142.8 171.25 133.2 172.5 127.4 175.15 122.1 177.5 118.7 181.7 L117.45 183.0 Q117.15 183.15 116.7 182.35 113.75 177.3 110.35 174.3 105.6 170.15 97.35 167.0 84.35 162.05 76.95 157.75 66.85 151.85 61.15 144.1 73.7 153.6 89.0 152.7 105.25 151.75 114.85 139.1 115.85 137.8 116.15 137.8 116.5 137.8 117.55 139.1 123.7 146.8 133.45 150.65 142.55 154.2 153.1 153.8 163.4 153.45 172.55 149.4"
        />
        <path
          fill="#0d131a"
          d="M195.65 75.75 Q195.95 98.15 189.15 114.4 183.1 128.7 172.5 136.25 162.8 143.15 152.0 142.85 141.5 142.5 134.05 135.5 123.35 125.4 126.75 111.6 129.9 98.7 141.9 92.55 155.35 85.65 169.85 79.35 L188.9 71.15 Q193.2 69.2 194.4 70.0 195.6 70.8 195.65 75.75"
        />
        <path
          fill="#0d131a"
          d="M52.0 82.9 Q52.6 76.15 54.3 75.6 55.8 75.1 61.7 79.0 L73.7 86.1 Q83.85 91.95 91.45 97.05 102.85 104.7 105.6 116.2 108.35 127.75 100.6 136.1 95.7 141.4 87.0 141.85 77.85 142.35 69.75 136.9 60.45 130.6 55.75 118.2 50.25 103.75 52.0 82.9"
        />
        <path
          fill="#152139"
          d="M53.5 85.3 Q54.05 78.15 55.25 77.7 56.35 77.35 62.8 81.65 L73.9 88.25 Q83.3 93.7 90.35 98.45 101.0 105.6 103.65 116.25 106.3 127.05 99.1 134.8 94.55 139.7 86.45 139.9 78.0 140.15 70.4 134.85 61.75 128.8 57.3 117.35 52.1 104.05 53.5 85.3"
        />
        <path
          fill="#152139"
          d="M193.75 75.4 Q194.45 96.5 188.2 112.4 182.6 126.6 172.45 134.3 163.0 141.5 152.35 141.1 141.7 140.65 133.8 132.65 125.7 124.4 128.8 112.1 131.85 99.9 142.95 94.3 161.15 85.1 189.8 72.8 192.65 71.45 193.2 71.95 193.65 72.3 193.75 75.4"
        />
        <path
          fill="#0d131a"
          d="M188.65 82.7 Q188.2 97.75 182.6 110.4 177.45 122.0 169.2 128.95 161.15 135.8 152.8 135.95 144.0 136.15 137.65 128.85 131.35 121.6 135.75 111.75 139.85 102.45 150.35 96.85 160.5 91.4 171.9 86.6 L185.15 80.95 Q187.3 79.9 188.0 80.3 188.7 80.65 188.65 82.7"
        />
        <path
          fill="#0d131a"
          d="M58.05 89.5 Q58.0 87.15 58.7 86.8 59.45 86.45 61.7 87.8 L73.5 94.65 86.9 102.75 Q97.2 109.5 98.85 118.55 100.3 126.3 95.45 131.65 91.85 135.7 85.75 135.55 79.45 135.4 73.55 130.7 58.55 118.7 58.05 89.5"
        />
        <path
          fill="#da4e70"
          d="M186.55 85.65 Q185.85 98.6 180.9 109.8 176.25 120.25 169.0 126.85 161.85 133.35 154.3 134.15 146.35 135.0 140.15 129.1 134.6 123.8 136.55 115.35 139.0 104.9 153.45 97.45 164.05 91.95 173.7 87.85 L184.55 83.3 Q185.75 82.7 186.2 83.1 186.7 83.6 186.55 85.65"
        />
        <path
          fill="#da4e70"
          d="M59.65 90.4 Q59.6 89.0 60.0 88.85 60.35 88.7 61.7 89.45 L74.45 97.05 Q84.05 102.6 87.75 105.5 96.15 112.05 97.25 119.9 98.1 126.2 94.45 130.25 90.75 134.4 84.9 133.85 79.0 133.3 73.45 128.25 59.9 115.95 59.65 90.4"
        />
        <path
          fill="#0d131a"
          d="M178.1 96.4 Q175.75 109.15 167.45 117.6 164.0 121.1 160.7 122.4 157.4 123.75 155.55 122.4 152.25 120.3 154.2 116.1 L149.9 115.85 Q148.0 115.0 147.5 113.4 146.75 111.1 148.5 108.95 150.4 106.65 155.3 104.3 L175.0 94.45 Q177.5 93.2 178.05 93.55 178.55 93.9 178.1 96.4"
        />
        <path
          fill="#efe908"
          d="M176.25 97.25 Q174.5 107.35 167.1 115.4 160.05 123.05 156.6 120.55 155.2 119.65 155.3 117.65 155.4 116.1 156.35 114.15 L152.15 114.5 Q150.2 114.1 149.7 112.85 148.85 110.75 150.95 108.8 152.65 107.25 157.4 104.95 L174.6 96.3 Q175.75 95.7 176.05 95.9 176.45 96.05 176.25 97.25"
        />
        <path
          fill="#0d131a"
          d="M75.05 121.5 Q72.1 118.2 69.9 112.7 67.9 107.65 66.85 101.7 66.5 99.85 66.85 99.65 67.2 99.45 68.5 100.45 L85.25 110.55 Q90.3 113.45 88.65 116.9 88.0 118.25 86.5 118.8 84.9 119.4 83.3 118.8 84.85 122.2 81.6 123.65 78.25 125.1 75.05 121.5"
        />
        <path
          fill="#efe908"
          d="M74.8 118.75 Q70.9 113.6 68.85 103.65 68.65 102.65 68.9 102.55 L70.25 103.3 76.05 107.05 83.7 111.4 Q86.0 112.55 86.8 113.9 87.6 115.2 86.95 116.55 86.45 117.45 84.85 117.65 L81.7 117.2 Q82.35 118.7 82.15 120.15 81.9 121.55 81.0 122.0 78.2 123.3 74.8 118.75"
        />
        <path
          fill="#675f80"
          d="M193.85 50.05 L201.75 55.0 Q206.75 58.2 210.85 60.25 197.75 55.25 193.25 53.85 183.5 50.85 170.95 48.9 159.15 47.05 144.2 54.4 139.5 56.7 135.1 59.65 L131.6 62.15 Q131.6 58.4 134.45 54.35 137.4 50.2 142.45 47.05 154.45 39.6 169.6 42.15 184.2 44.65 193.85 50.05"
        />
        <path
          fill="#675f80"
          d="M156.55 36.05 Q152.95 43.7 153.6 51.45 L154.4 57.5 Q154.8 60.95 154.55 63.5 154.2 66.65 152.75 67.95 L148.25 70.9 Q144.85 73.25 140.9 82.6 135.5 95.55 134.1 97.9 128.85 106.75 122.95 110.1 118.05 112.85 111.15 112.5 105.9 112.2 100.75 106.9 95.2 101.2 97.45 96.1 98.95 92.7 107.65 87.4 116.95 81.7 119.45 77.9 135.65 52.9 138.45 49.3 148.8 35.85 156.55 36.05"
        />
        <path
          fill="#0d131a"
          d="M167.95 66.15 L171.75 66.4 Q172.65 66.85 169.75 68.25 149.9 75.75 136.6 85.4 121.15 96.65 117.05 109.25 115.9 112.1 115.0 112.0 114.4 111.9 113.35 109.9 107.3 98.1 95.7 88.6 85.65 80.3 70.2 72.8 66.85 71.15 67.4 70.65 L70.7 70.3 Q77.35 70.35 88.6 75.45 101.1 81.1 114.5 90.95 126.05 80.55 143.75 73.05 159.0 66.55 167.95 66.15"
        />
        <path
          fill="#152139"
          d="M114.5 93.35 Q128.1 81.15 147.2 73.35 162.35 67.15 169.05 67.35 151.25 73.3 136.85 83.15 118.2 95.85 115.15 109.45 110.6 98.7 99.8 89.15 87.7 78.4 70.25 71.6 88.6 74.25 114.5 93.35"
        />
        <path
          fill="#0b132a"
          d="M101.95 91.1 Q103.6 89.85 106.75 87.9 L114.5 93.35 Q127.3 81.85 145.2 74.15 143.85 76.15 142.2 79.75 131.55 86.1 124.8 93.1 117.0 101.2 115.15 109.45 111.15 100.0 101.95 91.1"
        />
        <path
          fill="#0d131a"
          d="M121.4 83.15 Q120.5 83.2 119.9 80.05 L118.95 72.2 124.35 72.05 Q124.7 77.5 123.55 80.6 122.7 83.1 121.4 83.15"
        />
        <path
          fill="#0d131a"
          d="M172.1 34.6 L210.85 60.25 Q183.65 46.35 173.0 43.75 160.65 40.75 151.45 47.1 L152.65 56.5 Q153.55 63.4 152.55 64.6 145.75 66.4 140.6 74.05 137.95 77.95 132.7 89.45 128.05 99.7 124.45 103.9 119.0 110.3 111.4 110.35 95.25 110.45 89.85 96.6 88.5 93.2 86.35 83.95 84.4 75.7 82.45 71.7 80.85 68.4 78.7 65.1 L75.65 60.45 Q72.75 55.6 72.35 48.1 73.1 22.65 86.2 10.15 97.05 -0.2 113.75 0.0 123.9 0.1 132.55 4.5 139.0 7.75 146.45 14.6 L158.65 26.1 Q165.7 32.25 172.1 34.6"
        />
        <path
          fill="#827aa0"
          d="M168.5 35.05 L182.1 40.1 202.1 54.15 Q181.85 42.4 168.75 40.4 156.2 38.5 149.5 45.4 L149.85 54.9 Q149.95 62.0 148.95 63.2 142.85 65.2 138.2 72.6 136.0 76.05 131.05 87.35 126.85 96.95 123.4 101.0 118.3 107.0 111.05 107.1 96.65 107.3 91.75 94.0 90.65 90.95 88.55 81.95 86.8 74.1 84.9 70.25 L78.4 59.55 Q75.7 54.9 75.3 47.75 75.95 24.6 86.65 13.1 96.3 2.7 113.05 2.9 129.35 3.05 144.6 16.6 L156.2 27.3 Q162.8 32.95 168.5 35.05"
        />
        <path
          fill="#0d131a"
          d="M135.25 26.25 Q136.5 24.95 136.85 25.2 137.6 25.7 136.6 27.25 138.1 32.0 138.65 36.4 139.15 40.35 138.65 41.6 138.2 42.75 134.25 46.55 130.15 50.4 127.15 52.45 125.9 53.3 125.45 53.1 125.05 52.9 124.95 51.75 124.5 44.75 128.5 36.45 131.5 30.25 135.25 26.25"
        />
        <path
          fill="#ffffff"
          d="M137.45 40.55 Q137.2 41.65 132.65 45.8 127.95 50.05 127.0 49.5 125.15 48.5 128.8 39.25 132.4 29.95 135.25 28.55 136.9 31.9 137.4 36.0 137.8 39.2 137.45 40.55"
        />
        <path
          fill="#0d131a"
          d="M134.35 44.4 L129.4 50.05 Q128.05 51.25 125.1 52.8 124.7 50.1 126.95 42.7 129.25 35.15 131.25 32.85 132.8 34.4 133.65 38.1 134.45 41.3 134.35 44.4"
        />
        <path
          fill="#0d131a"
          d="M133.0 45.95 L127.9 50.75 126.35 50.7 Q125.45 50.1 126.9 44.25 128.4 38.3 130.25 36.0 131.7 37.9 132.45 41.25 133.05 43.9 133.0 45.95"
        />
        <path
          fill="#0d131a"
          d="M129.6 49.4 Q128.15 51.85 125.55 52.4 125.2 51.05 125.75 47.65 126.25 44.3 126.95 43.05 128.3 44.5 128.9 46.15 L129.6 49.4"
        />
        <path
          fill="#ffffff"
          d="M128.25 47.7 L128.75 49.7 126.15 51.8 Q126.15 47.75 126.85 45.15 127.8 46.3 128.25 47.7"
        />
        <path
          fill="#0d131a"
          d="M111.7 60.8 L112.0 60.8 111.85 61.1 109.7 63.25 108.55 64.5 Q107.6 65.35 107.3 65.0 107.0 64.7 107.8 63.7 109.25 61.9 111.7 60.8"
        />
        <path
          fill="#0d131a"
          d="M93.65 61.2 Q94.9 62.9 96.5 64.2 97.3 64.9 96.9 65.2 96.5 65.55 95.55 64.9 L94.25 63.5 93.25 61.45 93.2 60.9 Q93.3 60.65 93.65 61.2"
        />
        <path
          fill="#0d131a"
          d="M85.15 25.85 Q85.5 25.9 85.6 27.35 85.5 33.85 86.2 40.45 86.95 47.4 88.4 52.45 88.75 53.6 87.05 53.05 85.0 52.3 82.95 49.7 80.9 47.1 80.35 44.55 79.4 40.3 80.1 36.0 81.0 30.65 84.25 28.5 L84.65 26.55 Q84.85 25.8 85.15 25.85"
        />
        <path
          fill="#ffffff"
          d="M84.4 29.55 Q84.3 35.4 85.4 41.9 86.4 47.8 88.1 52.75 87.35 53.2 84.65 49.85 81.9 46.45 81.35 44.05 79.55 35.75 84.4 29.55"
        />
        <path
          fill="#0d131a"
          d="M82.4 47.75 Q81.25 45.7 81.5 41.65 81.9 36.45 85.1 33.35 85.35 39.45 86.1 44.05 86.7 47.65 88.1 52.75 87.35 53.2 85.5 51.6 83.55 49.95 82.4 47.75"
        />
        <path
          fill="#0d131a"
          d="M83.4 47.65 Q82.5 46.1 82.6 43.2 82.75 39.45 84.75 36.65 84.65 41.15 85.45 45.15 86.05 47.95 87.6 52.45 87.05 52.75 85.7 51.15 84.45 49.65 83.4 47.65"
        />
        <path
          fill="#0d131a"
          d="M84.3 47.75 Q84.6 46.0 86.25 44.4 86.55 47.0 87.25 49.3 L88.1 53.05 86.55 52.45 Q85.6 51.85 84.65 50.15 84.1 49.1 84.3 47.75"
        />
        <path
          fill="#ffffff"
          d="M87.6 52.45 Q86.5 51.8 85.75 50.6 84.6 48.9 86.1 46.5 86.6 49.45 87.6 52.45"
        />
        <path
          fill="#675f80"
          d="M145.3 59.0 Q140.5 61.5 136.45 66.6 L130.1 74.75 Q133.45 66.7 132.95 65.8 L136.35 62.9 Q139.25 60.8 145.3 59.0"
        />
        <path
          fill="#0d131a"
          d="M91.8 91.25 L88.2 79.3 Q85.85 71.8 82.85 67.3 87.4 71.35 93.05 70.0 L98.05 68.55 Q101.15 67.65 103.6 67.65 107.55 67.65 114.45 69.5 120.7 71.15 122.7 70.85 125.75 70.35 132.05 65.6 138.75 60.55 145.3 59.0 142.65 60.0 139.35 61.75 L136.55 63.25 Q133.05 68.05 130.2 76.0 L125.85 88.95 Q123.25 95.8 119.75 99.1 115.4 103.25 108.25 103.5 101.35 103.75 97.3 100.25 94.05 97.4 91.8 91.25"
        />
        <path
          fill="#922f00"
          d="M93.5 91.55 L90.45 81.35 Q88.45 74.85 85.75 70.8 89.95 73.7 95.05 72.0 L99.4 70.4 Q102.15 69.5 104.4 69.5 108.0 69.5 114.15 71.6 119.75 73.55 121.5 73.25 125.4 72.65 129.45 69.8 131.5 68.4 132.75 67.1 129.55 71.4 127.2 78.3 L123.7 89.45 Q121.55 95.3 118.5 98.05 114.6 101.6 107.9 101.8 101.7 102.05 98.2 99.1 95.35 96.75 93.5 91.55"
        />
        <path
          fill="#0d131a"
          d="M108.8 96.7 Q109.9 96.3 111.05 98.15 112.05 99.85 112.4 101.85 L107.5 102.85 Q106.65 99.75 107.0 98.45 107.3 97.3 108.8 96.7"
        />
        <path
          fill="#ffffff"
          d="M108.8 97.2 Q109.4 97.15 110.2 98.55 110.95 99.8 111.35 101.4 L111.3 101.4 108.2 101.75 107.95 101.75 Q107.7 97.35 108.8 97.2"
        />
        <path
          fill="#0d131a"
          d="M100.4 91.5 Q100.25 80.4 103.7 68.8 L108.55 69.45 113.3 70.7 Q109.85 83.85 109.85 94.7 109.8 102.1 111.7 111.7 113.9 122.95 114.2 126.9 114.95 135.95 112.75 145.75 111.65 158.7 117.6 168.25 120.55 173.0 123.75 175.2 119.95 174.65 115.8 171.5 107.6 165.3 106.2 152.5 96.5 165.0 85.65 168.55 82.25 169.65 79.15 169.75 L76.75 169.6 Q80.8 168.15 86.05 164.4 96.5 156.95 102.4 145.55 105.3 136.3 104.85 126.65 104.6 121.5 102.45 109.7 100.5 98.65 100.4 91.5"
        />
        <path
          fill="#ed8599"
          d="M101.7 91.5 Q101.45 80.55 104.7 69.5 108.55 69.65 112.15 70.95 108.55 83.5 108.35 94.25 108.2 101.8 109.9 111.25 112.15 123.6 112.4 126.15 113.25 134.75 111.4 143.2 109.9 156.5 115.05 166.35 117.65 171.3 120.5 173.55 117.65 172.2 114.5 168.6 108.25 161.35 107.0 149.95 96.9 161.95 87.3 166.75 82.5 169.15 79.7 169.15 83.25 168.5 88.1 165.1 97.75 158.35 104.3 144.85 107.05 136.05 106.5 126.5 106.2 121.4 103.95 109.6 101.85 98.5 101.7 91.5"
        />
        <path
          fill="#ce7486"
          d="M107.65 75.05 Q106.1 75.75 103.8 80.7 102.6 83.2 101.75 85.5 101.65 83.05 102.4 78.75 103.2 74.3 104.7 69.4 108.25 69.55 112.1 70.85 L109.8 80.8 Q109.6 80.5 109.35 77.0 109.1 74.4 107.65 75.05"
        />
        <path
          fill="#0d131a"
          d="M117.95 93.55 Q118.7 93.3 119.9 94.25 121.15 95.25 121.55 96.7 L117.2 100.4 Q116.55 98.2 116.75 96.1 116.95 93.9 117.95 93.55"
        />
        <path
          fill="#0d131a"
          d="M96.3 92.65 Q97.3 92.75 98.1 94.75 98.85 96.75 99.25 100.15 L95.2 97.0 Q94.75 96.0 95.1 94.3 95.5 92.6 96.3 92.65"
        />
        <path
          fill="#0d131a"
          d="M123.0 84.15 Q123.5 83.8 124.65 84.55 L126.4 86.45 123.7 92.4 Q122.2 89.5 122.25 86.85 122.25 84.7 123.0 84.15"
        />
        <path
          fill="#0d131a"
          d="M89.6 81.7 Q89.65 81.05 90.15 80.05 90.7 79.05 90.95 79.1 91.65 79.1 91.85 80.7 92.15 82.75 91.35 86.5 89.55 82.55 89.6 81.7"
        />
        <path
          fill="#0d131a"
          d="M91.2 87.35 L92.05 86.0 Q92.6 85.05 92.95 85.1 93.95 85.3 94.25 87.8 94.5 90.2 94.0 94.0 L92.4 90.95 Q90.85 87.8 91.2 87.35"
        />
        <path
          fill="#0d131a"
          d="M126.05 75.65 Q126.65 75.2 127.65 75.8 128.6 76.4 129.2 77.7 L126.45 84.15 Q125.3 81.9 125.2 79.05 125.1 76.25 126.05 75.65"
        />
        <path
          fill="#0d131a"
          d="M94.35 76.5 Q93.5 76.65 92.6 75.05 91.65 73.45 91.55 71.75 91.55 71.4 94.05 71.05 L96.55 70.8 Q96.65 72.65 95.9 74.5 95.2 76.4 94.35 76.5"
        />
        <path
          fill="#0d131a"
          d="M119.35 77.4 Q118.7 77.4 117.7 75.75 116.65 73.95 116.4 71.9 121.45 72.35 121.4 72.7 121.35 74.5 120.65 75.95 120.0 77.35 119.35 77.4"
        />
        <path
          fill="#ffffff"
          d="M118.1 94.5 Q118.45 94.2 119.15 94.65 119.95 95.2 120.35 96.3 119.15 97.85 117.7 98.85 117.4 95.15 118.1 94.5"
        />
        <path
          fill="#ffffff"
          d="M123.35 85.15 Q124.15 84.85 125.1 86.1 L123.65 90.3 Q123.1 88.45 123.05 86.85 122.95 85.35 123.35 85.15"
        />
        <path
          fill="#ffffff"
          d="M91.0 79.9 Q91.7 79.9 91.25 83.7 L90.5 81.4 Q90.5 80.85 90.65 80.35 L91.0 79.9"
        />
        <path
          fill="#ffffff"
          d="M92.9 85.9 Q93.25 85.95 93.45 87.85 L93.55 91.9 Q93.25 91.7 92.15 87.15 92.6 85.85 92.9 85.9"
        />
        <path
          fill="#ffffff"
          d="M126.4 76.45 Q127.0 75.95 127.95 77.05 L126.55 81.2 Q125.45 77.25 126.4 76.45"
        />
        <path
          fill="#ffffff"
          d="M96.35 93.45 Q96.85 93.45 97.4 95.3 L98.2 98.75 Q96.85 97.6 95.7 95.65 L95.8 94.15 Q96.0 93.45 96.35 93.45"
        />
        <path
          fill="#ffffff"
          d="M94.15 75.7 Q93.75 75.7 93.3 74.75 92.85 73.8 92.65 72.55 L95.5 71.75 Q95.55 73.05 95.1 74.35 94.65 75.7 94.15 75.7"
        />
        <path
          fill="#ffffff"
          d="M119.2 76.3 Q118.8 76.3 118.25 75.1 117.75 73.9 117.65 72.7 L120.35 73.2 119.95 75.35 Q119.6 76.3 119.2 76.3"
        />
        <path
          fill="#0d131a"
          d="M138.6 204.1 Q147.65 207.45 152.35 211.5 L151.9 212.75 Q147.45 209.05 138.3 205.8 127.95 202.1 118.55 201.75 111.15 201.5 103.4 203.25 94.8 205.2 89.1 208.95 L89.45 207.4 Q95.6 203.25 103.6 201.35 110.9 199.6 118.75 199.9 128.45 200.3 138.6 204.1"
        />
      </g>
    </svg>
  );
};

export default Arbok;
